module.exports = __webpack_public_path__ + "img/5-logo-portada-mobiles.7f42eb3d.png";